import qrcode from '@/static/images/qrcode.png'
import closeIcon from '@/static/images/close.png'
let floatingDiv
export function addConsult() {
    floatingDiv = document.createElement('div');
    floatingDiv.style.position = 'fixed';
    floatingDiv.style.top = '0';
    floatingDiv.style.left = '0';
    floatingDiv.style.width = '100%';
    floatingDiv.style.height = '100%';
    floatingDiv.style.zIndex = '1000';
    floatingDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
    floatingDiv.innerHTML = `
        <div style="position:fixed;top:15vh;left:50%;transform: translateX(-50%);background:#fff;border-radius: 10px;">
            <div style="position: relative;padding:30px;width:350px;text-align: center;">
                <h4>手机扫码添加微信</h4>
                <img src="${qrcode}" alt="手机扫码添加微信" style="width:230px;height:230px;margin-top:10px;">
                <img src="${closeIcon}" style="position: absolute;top:10px;right:10px;width:20px;height:20px;cursor: pointer;" id="closeBtn">
            </div>
            <script></script>
        </div>
    `;

    document.body.appendChild(floatingDiv);

    var btn=document.getElementById("closeBtn");
    btn.addEventListener('click', function() {
        if (floatingDiv && floatingDiv.parentNode) {
            // 从文档中移除悬浮窗元素
            floatingDiv.parentNode.removeChild(floatingDiv);
        }
    });


    return floatingDiv
}



// WEBPACK FOOTER //
// ./src/utils/consult.js